// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip--tooltip--SbutZ","label":"Tooltip--label--DvoDv","arrow":"Tooltip--arrow--us4Km"};